<div class="app-menu">
    <!-- Pastille de ville sous 600 px : la barre d'en-tête n'a plus la place de l'afficher. -->
    <mho-town-chip placement="menu"/>
    <mat-list>
        @for (route of routes; track $index) {
            <ng-container *ngTemplateOutlet="routeTemplate; context: {$implicit: route}"></ng-container>
            <mat-divider></mat-divider>
        }
    </mat-list>
    <div class="actions">
        @if (theme_family() === 'halloween') {
            <div class="pumpkin-container">
                <div class="pumpkin">
                    <div class="texture"></div>
                    <div class="root"></div>
                    <div class="eye left"></div>
                    <div class="eye right"></div>
                    <div class="mouth left"></div>
                    <div class="mouth right"></div>
                    <div class="teeth"></div>
                </div>

                <div class="shadow"></div>
            </div>
        }

        @if (site_language) {
            <button mat-button type="button" [matMenuTriggerFor]="languageMenu">
                <mat-icon>language</mat-icon>
                {{ site_language.label }}
                <mat-icon>arrow_drop_down</mat-icon>
            </button>
            <mat-menu #languageMenu="matMenu">
                @for (language of language_list; track language.code) {
                    <div mat-menu-item [disabled]="language.code === site_language.code"
                         [class.warn-color]="language.code === site_language.code" (click)="changeLanguage(language)">
                        {{ language.label }}
                    </div>
                }
            </mat-menu>
        }
        <button mat-button type="button" [matMenuTriggerFor]="themeMenu">
            <mat-icon>palette</mat-icon>
            {{ selected_theme()?.label }}
            <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #themeMenu="matMenu">
            @for (theme of themes; track theme.class) {
                <div mat-menu-item [disabled]="theme.class === selected_theme()?.class"
                     [class.warn-color]="theme.class === selected_theme()?.class" (click)="changeTheme(theme)">
                    {{ theme.label }}
                </div>
            }
        </mat-menu>
        <mat-button-toggle-group class="mho-theme-mode" [value]="theme_mode()" (valueChange)="changeMode($event)"
                                 i18n-aria-label aria-label="Mode d'affichage" hideSingleSelectionIndicator>
            <mat-button-toggle value="light" i18n-matTooltip matTooltip="Clair">
                <mat-icon>light_mode</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle value="dark" i18n-matTooltip matTooltip="Sombre">
                <mat-icon>dark_mode</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle value="auto" i18n-matTooltip matTooltip="Selon le système">
                <mat-icon>contrast</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>

        <!-- Mentions reprises du footer, supprimé : elles trouvent leur place ici sans coûter
             une centaine de pixels de hauteur sur chaque page. -->
        <div class="legal">
            <ng-container i18n>Développé par</ng-container>&nbsp;<a [href]="myhordes_url + 'jx/soul/6042'">Zerah</a>
            <span class="sep"> · </span><a href="https://discord.gg/ZQH7ZPWcCm" target="_blank" rel="noopener">Discord</a>
            <span class="sep"> · </span><a href="https://crowdin.com/project/myhordes-optimizer/invite?h=48c7b7811f6a618b31fd08945414e12d1646847"
                                           target="_blank" rel="noopener">Crowdin</a>
            <!--            <span class="sep"> · </span><a href="#" (click)="$event.preventDefault(); openThanks()" i18n>Remerciements</a>-->
            <br>
            <ng-container i18n>Non affilié à</ng-container>&nbsp;<a href="https://motion-twin.com/fr/" target="_blank" rel="noopener">Motion Twin</a>
            <ng-container i18n>&nbsp;ni à</ng-container>&nbsp;<a href="https://myhord.es" target="_blank" rel="noopener">MyHordes</a>
            <ng-container i18n>, à qui appartiennent certains éléments graphiques.</ng-container>
        </div>
    </div>
</div>

<ng-template #routeTemplate let-route>
    <ng-container *ngTemplateOutlet="routeLink; context: {$implicit: route}"></ng-container>
    @if (route.children && route.children.length > 0) {
        @for (sub_route of route.children; track sub_route) {
            <ng-container *ngTemplateOutlet="routeTemplate; context: {$implicit: sub_route}"></ng-container>
        }
    }
</ng-template>

<ng-template #routeLink let-route>
    @if (route.displayed && route.authorized()) {
        <a mat-list-item routerLinkActive="link-selected"
           [routerLinkActiveOptions]="{exact : true}" [routerLink]="resolvePath(route)"
           (click)="route.expanded = !route.expanded; toggleDisplayChildren(route)" [class]="`lvl-${route.lvl}`">
            <div style="width: 100%;">
                @if (route.children && route.children.length > 0) {
                    <mat-icon>{{ route.expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
                }
                {{ resolveLabel(route) }}
                @if (route.spoil) {
                    <span class="spoil" matTooltip="Cette page peut contenir des spoils de la saison 19" i18n-matTooltip>Spoil S19</span>
                }
            </div>
        </a>
    }
</ng-template>
